export default __webpack_public_path__ + "static/media/group-icon.1ea0fa1c.png";